// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"634eb0d1","122":"3fd9e383","131":"97c101bf","206":"b1b0d522","256":"5c485768","398":"5b28aee5","797":"4fd79f26"}[chunkId] + ".chunk.js";
};